// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"h3-z"};